import { formatCurrency } from "../../include/money";
import { useContext, useEffect, useRef, useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { callPostApi } from "../../function/ApiCallFunction";
import { DataContext } from "../../context/DataContext";
import { consoleColors, primaryButtonSx } from "../admin/consoleTheme";

const StorePayResponse = () => {
  const navigate = useNavigate();
  const calledRef = useRef(false);
  const { loginData } = useContext(DataContext);
  const [state, setState] = useState({ loading: true, amount: "", txnid: "", storeId: "" });

  useEffect(() => {
    if (calledRef.current) return;
    calledRef.current = true;

    const params = new URLSearchParams(window.location.search);
    const payload = Object.fromEntries(params.entries());

    const confirmPayment = async () => {
      try {
        await callPostApi("store-pay-failure", payload);
      } catch {
        /* the receipt still shows from the return link */
      }
      setState({
        loading: false,
        amount: payload.amount || "",
        txnid: payload.txnid || "",
        storeId: payload.store_id || "",
      });
    };

    confirmPayment();
  }, []);

  const walletPath = loginData?.store_info?.cashi_plus_flag === "2" ? "/dashboardPlus/walletPlus" : "/wallet";
  const goWallet = () => navigate(loginData?.store_info?.store_id ? walletPath : "/");

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: consoleColors.page, p: 2 }}>
      <Box sx={{ width: "100%", maxWidth: 440, background: "#fff", border: `1px solid ${consoleColors.line}`, borderRadius: 3, p: { xs: 3, sm: 4 }, textAlign: "center" }}>
        <Typography sx={{ letterSpacing: 1.4, fontSize: 12, color: "#93c5fd", fontWeight: 700, textAlign: "left" }}>CASHI</Typography>
        {state.loading ? (
          <Box sx={{ py: 6 }}>
            <CircularProgress size={28} sx={{ color: consoleColors.accent }} />
            <Typography sx={{ mt: 2, color: consoleColors.muted }}>Updating payment status</Typography>
          </Box>
        ) : (
          <>
            <Box sx={{ width: 64, height: 64, borderRadius: "50%", mx: "auto", mt: 3, mb: 2, display: "flex", alignItems: "center", justifyContent: "center", background: "#fee2e2", color: "#b91c1c" }}>
              <ErrorOutline sx={{ fontSize: 34 }} />
            </Box>
            <Typography sx={{ fontSize: 26, fontWeight: 700, color: consoleColors.ink }}>Payment failed</Typography>
            <Typography sx={{ mt: 1, color: consoleColors.muted, fontSize: 14 }}>The amount was not added to your wallet.</Typography>
            <Box sx={{ mt: 3, border: `1px solid ${consoleColors.line}`, borderRadius: 2, textAlign: "left" }}>
              <Box sx={{ px: 2, py: 1.4, display: "flex", justifyContent: "space-between", gap: 2, borderBottom: `1px solid ${consoleColors.line}` }}>
                <Typography sx={{ fontSize: 13, color: consoleColors.muted }}>Amount</Typography>
                <Typography sx={{ fontSize: 14, fontWeight: 650, color: consoleColors.ink }}>{state.amount ? formatCurrency(state.amount) : "—"}</Typography>
              </Box>
              <Box sx={{ px: 2, py: 1.4, display: "flex", justifyContent: "space-between", gap: 2, borderBottom: `1px solid ${consoleColors.line}` }}>
                <Typography sx={{ fontSize: 13, color: consoleColors.muted }}>Transaction</Typography>
                <Typography sx={{ fontSize: 14, fontWeight: 650, color: consoleColors.ink, wordBreak: "break-all" }}>{state.txnid || "—"}</Typography>
              </Box>
              <Box sx={{ px: 2, py: 1.4, display: "flex", justifyContent: "space-between", gap: 2 }}>
                <Typography sx={{ fontSize: 13, color: consoleColors.muted }}>Store</Typography>
                <Typography sx={{ fontSize: 14, fontWeight: 650, color: consoleColors.ink }}>{state.storeId || "—"}</Typography>
              </Box>
            </Box>
            <Button variant="contained" fullWidth sx={{ ...primaryButtonSx, mt: 3, py: 1.1 }} onClick={goWallet}>
              {loginData?.store_info?.store_id ? "Back to wallet" : "Back to sign in"}
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
};

export default StorePayResponse;
